"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactI18next = require("react-i18next");

var _getConfig = _interopRequireDefault(require("@jobmatchme/profile-components/es/resources/getConfig"));

var _ModalDialog = _interopRequireDefault(require("@jobmatchme/ui/es/components/ModalDialog"));

var _ConfiguredFunnel = _interopRequireDefault(require("@jobmatchme/pc-funnel/es/components/ConfiguredFunnel"));

var _Actions = _interopRequireDefault(require("./Actions"));

var _Route = require("../../provider/Route");

var _Profile = require("../../provider/Profile");

var _Matches = require("../../provider/Matches");

var _Vertical = require("../../provider/Vertical");

var _verticals = require("@jobmatchme/utils/es/verticals");

var _vertical = require("@jobmatchme/utils/es/types/vertical");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function isOpenDialogType(maybeOpenDialogType) {
  return typeof maybeOpenDialogType.actionType !== 'undefined';
}

function isNewDialogType(maybeNewDialogType) {
  return maybeNewDialogType.actionType === 'New';
}

function dialogValues(confirmation) {
  if (isOpenDialogType(confirmation)) {
    return {
      questions: isNewDialogType(confirmation) ? confirmation.questions : 0,
      translatedVertical: confirmation.translatedVertical
    };
  }

  return {
    questions: 0,
    translatedVertical: ''
  };
}

var NoConfirmationDialog = {
  actionType: undefined
};
var translateNs = 'pc-matching:VerticalSelection';
var verticalNs = 'pc-matching:Vertical';

var getVariant = function getVariant(selectedVertical) {
  if (typeof selectedVertical === 'undefined') {
    return 'jmm';
  }

  if (selectedVertical === 'care') {
    return selectedVertical;
  }

  return 'truck';
};

var VerticalSelection = function VerticalSelection(_ref) {
  var selection = _ref.selection,
      _ref$configKey = _ref.configKey,
      configKey = _ref$configKey === void 0 ? 'funnel' : _ref$configKey,
      _ref$initial = _ref.initial,
      initial = _ref$initial === void 0 ? false : _ref$initial,
      _ref$noReroute = _ref.noReroute,
      noReroute = _ref$noReroute === void 0 ? false : _ref$noReroute;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var _useContext = (0, _react.useContext)(_Route.RouteActionsContext),
      routeInternal = _useContext.routeInternal;

  var _useContext2 = (0, _react.useContext)(_Profile.ProfileActionsContext),
      createProfile = _useContext2.createProfile;

  var _useContext3 = (0, _react.useContext)(_Vertical.VerticalContext),
      vertical = _useContext3.vertical,
      verticals = _useContext3.verticals,
      setVertical = _useContext3.setVertical,
      setVerticals = _useContext3.setVerticals;

  var _useContext4 = (0, _react.useContext)(_Matches.MatchesActionsContext),
      fetchMatches = _useContext4.fetchMatches,
      executeWhileLoading = _useContext4.executeWhileLoading;

  var _useState = (0, _react.useState)(selection),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      selectedVertical = _useState2[0],
      setSelectedVertical = _useState2[1];

  var _useState3 = (0, _react.useState)(NoConfirmationDialog),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      confirmation = _useState4[0],
      setConfirmation = _useState4[1];

  var selectedConfig = typeof selectedVertical === 'undefined' ? undefined : (0, _getConfig.default)(selectedVertical)('pc');

  var loadableConfigs = _verticals.verticals.reduce(function (result, v) {
    var newResult = (0, _extends2.default)({}, result);
    newResult[v] = (0, _getConfig.default)(v)('pc');
    return newResult;
  }, {});

  var onComplete = (0, _react.useCallback)(function (profile, cleanup) {
    if (!profile.discriminator) {
      return;
    }

    var addedVertical = (0, _vertical.isVerticalType)(profile.discriminator) ? profile.discriminator : undefined;

    if (!addedVertical) {
      return;
    }

    return executeWhileLoading([function () {
      return new Promise(function (resolve) {
        if (!noReroute) {
          routeInternal('appHome', {}, {
            vertical: addedVertical
          });
        }

        resolve();
      });
    }, function () {
      return createProfile(profile, initial).then(function () {
        var updatedVerticals = typeof verticals !== 'undefined' ? (0, _toConsumableArray2.default)(verticals) : [];
        updatedVerticals.push(addedVertical);
        setVerticals(updatedVerticals);
        setVertical(addedVertical);
      });
    }, function () {
      return fetchMatches(profile);
    }]);
  }, [executeWhileLoading, fetchMatches, createProfile, routeInternal, verticals, setVerticals, setVertical, initial, noReroute]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ConfiguredFunnel.default, {
      resettable: true,
      variant: getVariant(selectedVertical || vertical),
      config: selectedConfig,
      configKey: configKey,
      loadableConfigs: loadableConfigs,
      preselection: vertical,
      onCancel: function onCancel() {
        return routeInternal('profile');
      },
      buttonLeftText: t("".concat(translateNs, ".Navigation.cancel")),
      onFunnelCancel: function onFunnelCancel() {
        setSelectedVertical(selection);
        routeInternal('vertical');
      },
      onConfiguredConfirm: function onConfiguredConfirm(config) {
        return new Promise(function (resolve) {
          var configuredVertical = (0, _vertical.isVerticalType)(config.discriminator) ? config.discriminator : undefined;

          if (!configuredVertical) {
            return;
          }

          var abort = function abort() {
            setConfirmation(NoConfirmationDialog);
            setSelectedVertical(vertical);
            resolve(false);
          };

          var confirm;

          if (typeof verticals !== 'undefined' && verticals.indexOf(configuredVertical) !== -1) {
            confirm = function confirm() {
              resolve(true);
              setConfirmation(NoConfirmationDialog);
              setVertical(configuredVertical);
              routeInternal('profile', undefined, {
                vertical: configuredVertical
              });
            };

            setConfirmation({
              actionType: 'Switch',
              translatedVertical: t("".concat(verticalNs, ":").concat(config.discriminator)),
              abort: abort,
              confirm: confirm
            });
          } else {
            var _;

            confirm = function confirm() {
              resolve(true);
              setConfirmation(NoConfirmationDialog);
              setSelectedVertical(configuredVertical);

              switch (configuredVertical) {
                case 'truck':
                  routeInternal('verticalTruck', undefined, undefined, {
                    optimisticProfile: {
                      discriminator: configuredVertical
                    }
                  });
                  break;

                case 'logistics-scheduler':
                  routeInternal('verticalLogisticsScheduler', undefined, undefined, {
                    optimisticProfile: {
                      discriminator: configuredVertical
                    }
                  });
                  break;

                case 'service-gastro':
                  routeInternal('verticalServiceGastro', undefined, undefined, {
                    optimisticProfile: {
                      discriminator: configuredVertical
                    }
                  });
                  break;

                case 'care':
                  routeInternal('verticalCare', undefined, undefined, {
                    optimisticProfile: {
                      discriminator: configuredVertical
                    }
                  });
                  break;

                default:
                  break;
              }
            };

            setConfirmation({
              actionType: 'New',
              questions: (((_ = (config.funnel || [])[0]) === null || _ === void 0 ? void 0 : _.steps) || []).length,
              translatedVertical: t("".concat(verticalNs, ":").concat(config.discriminator)),
              abort: abort,
              confirm: confirm
            });
          }
        });
      },
      onComplete: onComplete
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ModalDialog.default, {
      id: "confirmationDialog",
      title: t("".concat(translateNs, ".Confirm.").concat(confirmation.actionType || '', ".title"), dialogValues(confirmation)),
      showDividers: false,
      verticalMobilePosition: 'bottom',
      opacity: 0.5,
      open: Boolean(confirmation.actionType),
      onClose: isOpenDialogType(confirmation) ? confirmation.abort : false,
      dialogActions: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Actions.default, {
        actionType: confirmation.actionType,
        abort: isOpenDialogType(confirmation) ? confirmation.abort : function () {},
        confirm: isOpenDialogType(confirmation) ? confirmation.confirm : function () {}
      }),
      children: t("".concat(translateNs, ".Confirm.").concat(confirmation.actionType, ".description"), dialogValues(confirmation))
    })]
  });
};

var _default = VerticalSelection;
exports.default = _default;